import { useCallback, useEffect, useRef, useState } from "react"

export function useLocalStorage(key, initialValue) {
  const fallback = useRef(initialValue)
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key)
      return item ? JSON.parse(item) : initialValue
    } catch (error) {
      return initialValue
    }
  })

  useEffect(() => {
    const sync = event => {
      const changedKey = event.key || event.detail?.key
      if (changedKey && changedKey !== key) return
      try {
        const value = window.localStorage.getItem(key)
        setStoredValue(value ? JSON.parse(value) : fallback.current)
      } catch (_) { setStoredValue(fallback.current) }
    }
    window.addEventListener("storage", sync)
    window.addEventListener("zonda-storage", sync)
    return () => {
      window.removeEventListener("storage", sync)
      window.removeEventListener("zonda-storage", sync)
    }
  }, [key])

  const setValue = useCallback((value) => {
    try {
      setStoredValue(value)
      window.localStorage.setItem(key, JSON.stringify(value))
      window.dispatchEvent(new CustomEvent("zonda-storage", { detail: { key } }))
    } catch (error) {
      console.error(error)
    }
  }, [key])
  return [storedValue, setValue]
}
